import axiosInstance from './axiosInstance';

const BASE = '/shop-admin';

export const getCategorie    = ()         => axiosInstance.get(`${BASE}/categorie`).then(r => r.data);
export const createCategoria = (data)     => axiosInstance.post(`${BASE}/categorie`, data).then(r => r.data);
export const updateCategoria = (id, data) => axiosInstance.put(`${BASE}/categorie/${id}`, data).then(r => r.data);
export const deleteCategoria = (id)       => axiosInstance.delete(`${BASE}/categorie/${id}`).then(r => r.data);

export const getProdotti     = ()         => axiosInstance.get(`${BASE}/prodotti`).then(r => r.data);
export const createProdotto  = (data)     => axiosInstance.post(`${BASE}/prodotti`, data).then(r => r.data);
export const updateProdotto  = (id, data) => axiosInstance.put(`${BASE}/prodotti/${id}`, data).then(r => r.data);
export const toggleVisibilita = (id, visibile) => axiosInstance.patch(`${BASE}/prodotti/${id}/visibilita`, { visibile }).then(r => r.data);
export const deleteProdotto  = (id)       => axiosInstance.delete(`${BASE}/prodotti/${id}`).then(r => r.data);

export const getRichieste      = ()  => axiosInstance.get(`${BASE}/richieste`).then(r => r.data);
export const getRichiesteCount = ()  => axiosInstance.get(`${BASE}/richieste/count`).then(r => r.data);

export const getTemplates = () => axiosInstance.get(`${BASE}/templates`).then(r => r.data);
export const getTemplateInfo = (prodottoId) => axiosInstance.get(`${BASE}/prodotti/${prodottoId}/template-info`).then(r => r.data);
